import React from 'react';
import styled, { useTheme } from 'styled-components';

const StyledButton = styled.button.withConfig({
  shouldForwardProp: (prop) => !['bgColor', 'textColor', 'height', 'width', 'radius'].includes(prop),
})`
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ textColor }) => textColor};
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  border: none;
  padding: 0.5rem 1rem;
  border-radius: ${({ radius }) => radius};
  font-size: 1rem;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.3s ease, opacity 0.3s ease;
  opacity: ${({ disabled }) => disabled ? 0.5 : 1};

  &:hover {
    opacity: ${({ disabled }) => disabled ? 0.5 : 0.85};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;


function Button({ tekst, akcija, visina = 'auto', sirina = 'auto', radius = '8px', bojaPozadine, bojaTeksta, type = 'button', disabled = false }) {
  const theme = useTheme();

  const bgColor = bojaPozadine || theme.colors.primary;
  const textColor = bojaTeksta || theme.colors.textSecondary;

  return (
    <StyledButton
      onClick={akcija}
      height={visina}
      width={sirina}
      radius={radius}
      bgColor={bgColor}
      textColor={textColor}
      type={type}
      disabled={disabled}
    >
      {tekst}
    </StyledButton>
  );
}


export default Button;
